var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "field-panel panel-header" },
    [
      _c("search_from", {
        attrs: {
          placeholder: "Search",
          list: _vm.field_settings,
          isSidebarSearch: _vm.isSidebarSearch
        },
        on: {
          "update:isSidebarSearch": function($event) {
            _vm.isSidebarSearch = $event
          },
          "update:is-sidebar-search": function($event) {
            _vm.isSidebarSearch = $event
          }
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.panel_sections, function(section, index) {
        return _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isSidebarSearch,
                expression: "!isSidebarSearch"
              }
            ],
            key: index,
            staticClass: "panel-form-fields"
          },
          [
            _c(
              "h3",
              {
                on: {
                  click: function($event) {
                    return _vm.panel_toggle(index)
                  }
                }
              },
              [
                _vm._v(_vm._s(section.title) + "\n      "),
                _c("i", {
                  class: [
                    section.show ? "fa fa-angle-down" : "fa fa-angle-right"
                  ]
                })
              ]
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "slide-fade" } }, [
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: section.show,
                      expression: "section.show"
                    }
                  ]
                },
                [_c("fields_button", { attrs: { fields: section.fields } })],
                1
              )
            ])
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }